export const SET_NUMBER_OF_TRACKERS = "SET_NUMBER_OF_TRACKERS";
export const SET_NUMBER_OF_TRACKERS_LIMIT = "SET_NUMBER_OF_TRACKERS_LIMIT";
export const IS_LOADING_METER_DATA = "IS_LOADING_METER_DATA";
export const IS_SHARE_TRACKER_MODAL_OPEN = "IS_SHARE_TRACKER_MODAL_OPEN";
